import Flex from 'typescript-styled-flex'
import is, { isNot } from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'

const ContentArea = styled(Flex.withComponent('main') as any)<
  IContentAreaProps
>`
  transition: all 0.2s ease-in-out;
  transform: translateZ(0);
  flex-direction: column;
  height: calc(var(--full) - ${({ size }) => (size ? 56 * size : 56)}px - var(--beta-banner-height, 0px));
  min-height: calc(var(--full) - ${({ size }) => (size ? 56 * size : 56)}px - var(--beta-banner-height, 0px));

  & > * {
    flex: 1 1 auto;
    min-height: 0;
  }

  margin-right: auto;
  margin-left: auto;
  padding-right: ${({ size, isv2 }) =>
    isv2 ? '0' : size ? 0.75 * size : 0.75}rem;
  padding-left: ${({ size, isv2 }) =>
    isv2 ? '0' : size ? 0.75 * size : 0.75}rem;

  @media (min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    padding-right: ${({ size, isv2 }) => (isv2 ? '0' : size ? size : 1)}rem;
    padding-left: ${({ size, isv2 }) => (isv2 ? '0' : size ? size : 1)}rem;
    ${is('isSidebarOpen')`
      padding-left: calc(${({ size, isv2 }) =>
        isv2 ? '0' : size ? size : 1}rem + 240px);
    `}
    ${isNot('isSidebarOpen')`
      padding-left: calc(${({ size, isv2 }) =>
        isv2 ? '0' : size ? size : 1}rem + ${({ size }) =>
      size ? 54 * size : 54}px);
    `}
  }
`

export default ContentArea

export interface IContentAreaProps {
  isSidebarOpen: boolean
  size?: number
  isv2?: boolean
}
